// @flow
import Temperature from './component';
import { connect } from 'react-redux';
import { getConfig } from '~/core/state/config/selectors';

const mapStateToProps = (state, { unit = getConfig(state, 'temperatureUnit') }) => ({ unit });

// $FlowFixMe
export default connect(mapStateToProps)(Temperature);



// WEBPACK FOOTER //
// ./src/components/widgets/temperature/index.js